<form [formGroup]="formGroup" id="habitsForm">
  <div class="mb-8" *ngFor="let question of habitQuestions">
    <label class="form-label fw-bold mb-2">{{
      question.label | translate
    }}</label>
    <div *ngIf="question.type === 'radio'">
      <div class="d-flex align-items-center w-100">
        <div class="w-100">
          <label class="form-label text-black mb-1" [for]="question.id">
            {{ formGroup.get(question.controlName)?.value }}
          </label>
          <input
            type="range"
            class="form-range"
            [formControlName]="question.controlName"
            [min]="ratingValues[0]"
            [max]="ratingValues[ratingValues.length - 1]"
            [step]="1"
            [id]="question.id"
          />
          <div class="d-flex justify-content-between mt-1 text-muted small">
            <span *ngFor="let value of ratingValues">{{ value=== 1 ? 'Hiç' : value === 10 ? 'Kesinlikle' : value }}</span>
          </div>
        </div>
      </div>
      <div
        *ngIf="isControlInvalid(question.controlName)"
        class="text-danger mt-2"
      >
        {{ "fieldRequired" | translate }}
      </div>
    </div>
    <div *ngIf="question.type === 'select'" class="row">
      <div class="col-xl-3 col-md-6">
        <select class="form-select" [formControlName]="question.controlName">
          <option [ngValue]="null" disabled>
            {{ question.label | translate }}
          </option>
          <option *ngFor="let value of question.options" [ngValue]="value.id">
            {{ value.text }}
          </option>
        </select>
        <div
          *ngIf="isControlInvalid(question.controlName)"
          class="text-danger mt-2"
        >
          {{ "fieldRequired" | translate }}
        </div>
      </div>
    </div>
  </div>

  <!-- Next Step Button -->
  <div class="text-end">
    <button
      (click)="goToNextStep()"
      type="submit"
      class="btn btn-sm btn-primary cursor-pointer"
    >
      {{ "nextStep" | translate }}
    </button>
  </div>
</form>
